import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSwapPageQueryParams } from './useSwapPageQueryParams';
import { GenericErrorPageLayout } from '../GenericErrorPage';
import { SwapPageWithValidUrlParam } from './SwapPageWithValidUrlParam';
import { useIsValidSwapQueryParam } from './useIsValidSwapQueryParam';
export var SwapPage = function () {
    var t = useTranslation().t;
    var shiftStart = useSwapPageQueryParams().shiftStart;
    var isValidSwapQueryParam = useIsValidSwapQueryParam({
        shiftStart: shiftStart
    });
    var noSwapsAvailableError = (React.createElement(GenericErrorPageLayout, { titleText: t('shift_management_features_no_swaps_available_error_title'), bodyText: t('shift_management_features_no_swaps_available_error_subtitle'), buttonText: t('shift_management_features_no_swaps_available_error_button_text'), buttonAction: function () { return history.back(); } }));
    if (!isValidSwapQueryParam) {
        return noSwapsAvailableError;
    }
    else {
        return (React.createElement(SwapPageWithValidUrlParam, { swapFromShiftStart: shiftStart, noSwapsAvailableError: noSwapsAvailableError }));
    }
};
